import axios, { AxiosInstance } from 'axios';
import { errorAxiosInterceptor } from './error-interceptor';
import { IAppState } from 'shared/app';
import { sessionAxiosInterceptor } from './session-axios-interceptor';
import { injectLanguageInterceptor } from './inject-language-interceptor';

export function setupAxios(store: { getState(): IAppState }): AxiosInstance {
  const instance = axios;
  instance.defaults.timeout = 10000;
  instance.interceptors.request.use(injectLanguageInterceptor);
  instance.interceptors.request.use(sessionAxiosInterceptor);
  instance.interceptors.response.use(undefined, errorAxiosInterceptor);

  return instance;
}
